export const CUSTOMER_LOAD = 'CUSTOMER_LOAD';
export const CUSTOMER_LOADED = 'CUSTOMER_LOADED';
export const CUSTOMER_REGISTER = 'CUSTOMER_REGISTER';
export const CUSTOMER_FORGET_PASSWORD = 'CUSTOMER_FORGET_PASSWORD';
export const CUSTOMER_PASSWORD_RESET_BY_CODE = 'CUSTOMER_PASSWORD_RESET_BY_CODE';
export const CUSTOMER_PASSWORD_RESET = 'CUSTOMER_PASSWORD_RESET';
export const CUSTOMER_SUMBIT_OK = 'CUSTOMER_SUMBIT_OK';
